import { render, staticRenderFns } from "./phone.html?vue&type=template&id=339249d1&scoped=true&"
import script from "./phone.js?vue&type=script&lang=js&"
export * from "./phone.js?vue&type=script&lang=js&"
import style0 from "./phone.scss?vue&type=style&index=0&id=339249d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339249d1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VRow,VTextField})
